import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useId } from "react";

type SettingsSectionProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

/**
 * One section of Settings: a landmark named by its own heading, so a screen reader can list the
 * sections and jump to one, and a sentence that says what the section changes and where it is kept.
 */
export default function SettingsSection(props: Readonly<SettingsSectionProps>) {
  const headingId = useId();

  return (
    <Paper aria-labelledby={headingId} component="section" elevation={1} sx={{ p: { xs: 2, sm: 3 } }}>
      <Stack spacing={2}>
        <div>
          <Typography component="h2" id={headingId} variant="h6">{props.title}</Typography>
          <Typography color="text.secondary" variant="body2">{props.description}</Typography>
        </div>
        {props.children}
      </Stack>
    </Paper>
  );
}
